module.exports = __webpack_public_path__ + "static/img/img_7.8fd9018c.jpg";